// extracted by mini-css-extract-plugin
export default {"wrapper":"s3-z","play":"t3-z"};